/* eslint-disable max-len */
// noinspection CssUnusedSymbol

// language=CSS
export const COMMON_PDF_CSS = `
  *, ::after, ::before {
    box-sizing: border-box;
    word-break: break-word !important;
  }

    @page 
    {
        size:  auto;   /* auto is the initial value */
        margin: 8mm;  /* this affects the margin in the printer settings */
    }

    html
    {
        background-color: #FFFFFF; 
        margin: 0px;  /* this affects the margin on the html before sending to printer */
    }


  body {
    font-family: 'Helvetica Neue', Arial, sans-serif;
    margin: 5mm; /* margin for the content */
  }
  
  .d-lg-block {
    display: block !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .d-none {
    display: none !important;
  }

  .d-none.d-lg-flex {
    display: flex !important;
  }

  .d-flex {
    display: flex;
  }

  .pdf-reactor-d-none {
    display: none !important;
  }

  .d-none.pdf-reactor-block,
  .pdf-reactor-block {
    display: block !important;
  }
  
  .flex-row {
    flex-direction: row;
  }

  .flex-column {
    flex-direction: column;
  }

  .align-items-start {
    align-items: flex-start !important;
  }

  .align-items-center {
    align-items: center !important;
  }

  .align-items-end {
    align-items: flex-end !important;
  }

  .justify-content-center {
    justify-content: center !important;
  }

  .justify-content-around {
    justify-content: space-around !important;
  }

  .visually-hidden {
    display: none;
  }

  .w-100 {
    width: 100% !important;
  }

  .mb-5 {
    margin-bottom: 3rem;
  }

  .mt-4 {
    margin-top: 1.5rem !important;
  }

  .mt-5 {
    margin-top: 3rem !important;
  }

  .ms-2 {
    margin-left:.5rem !important
  }

  .me-4 {
    margin-right: 1.5rem !important;
    flex: 0 0 12%;
  }

  .pt-2 {
    padding-top: .5rem !important;
  }

  .pt-3 {
    padding-top: 1rem !important;
  }

  .ps-0 {
    padding-left: 0 !important;
  }

  .pe-0 {
    padding-right: 0 !important;
  }

  .pb-3 {
    padding-bottom: 1rem !important;
  }

  .pt-4 {
    padding-top: 1.5rem !important;
  }

  .break-after-avoid {
    break-after: avoid-page;
  }

  .break-after {
    break-after: page;
  }

  .break-before-avoid {
    break-before: avoid-page;
  }

  .break-before {
    break-before: page;
  }

  .border-yellow, .border-red, .border-purple, .border-green, .border-blue {
    border: 1px solid;
  }

  .border-blue {
    border-color: blue;
  }

  .border-green {
    border-color: green;
  }

  .border-purple {
    border-color: purple;
  }

  .border-red {
    border-color: red;
  }

  .border-yellow {
    border-color: yellow;
  }

  /* Sidecard styling */
  .logo1 {
    width: 137px;
    height: 45px;
  }

  .logo-appcard {
    flex-flow: row;
    flex-wrap: wrap;
    font-size: 0.75rem;
    display: flex;
    width: 100%;
  }

  .logo-appcard > h1, .card-body h1 {
    color: #0295be;
    text-decoration: none;
    border-bottom: none !important;
  }

  .logo-appcard > h1 {
    line-height: 1.3;
    font-size: 1rem;
  }

  .logo-appcard > *:nth-child(2) {
    border-left: 0.0625rem solid lightgrey;
    border-right: 0.0625rem solid lightgrey;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-left: -0.0625rem;
    margin-right: -0.0625rem;
  }

  app-card {
    /* col-5 */
    display: flex;
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 1.5rem;
  }
  
  app-card .card {
    width: 100%;
  }

  .card-body h1 {
    line-height: 1;
    font-size: 0.75rem;
    color: unset;
    margin-left: -0.5rem;
    margin-bottom: 0.5rem;
  }

  .card * {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
  }

  .sidecard-content {
    width: 100%;
  }

  .sidecard-row {
    display: flex;
    flex-flow: row;
  }

  .sidecard-row > div {
    padding-bottom: 0.5rem !important;
    /*justify-content: center;*/
    align-content: center;
    align-items: center;
    display: flex;
    width: 100%;
  }
  
  .sidecard-row > div:nth-child(3n+1):nth-last-child(1),
  .sidecard-row > div:nth-child(3n+2):nth-last-child(1) {
    flex: 0 0 32%; /* check if two divs are present then 2 divs with width 32% and 64% is shown as usual */
    max-width: 32%;
  }
  .sidecard-row > div:nth-child(3n+2):nth-last-child(1) {
    flex: 0 0 64%;
    max-width: 64%;
  }

  .sidecard-row > div:nth-child(3n) {
    flex: 0 0 33%; /* check if three divs are present then 3 divs each with 33% width is shown */
    max-width: 33%;
  }
  .sidecard-row > div:nth-child(3n+1):nth-last-child(n+2),
  .sidecard-row > div:nth-child(3n+2):nth-last-child(n+2) {
    flex: 0 0 33%;
    max-width: 33%;
  }
`;
